import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

interface UseAuthCredentialsStoreState {
  email: string
  setAuthCredentials: (email: string) => void
  resetAuthCredentials: () => void
}

export const useAuthCredentialsStore = create<UseAuthCredentialsStoreState>()(
  persist(
    (set) => ({
      email: '',
      setAuthCredentials: (email) => set(() => ({ email })),
      resetAuthCredentials: () => set(() => ({ email: '' })),
    }),
    {
      name: 'authCredentialsStore',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({ email: state.email }),
    },
  ),
)
